import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import customerReducer from '../features/customer/customerSlice'
import orderReducer from '../features/order/orderSlice'
import metaReducer from '../features/meta/metaSlice'
import { logMiddleware } from '../GlobalComponents/Logger'
import alertDialogReducer from '../features/alertDialog/alertDialogSlice'
import appReducer from '../features/app/appSlice'
import assetSelectReducer from '../features/assetSelect/assetSelectSlice'
import customerTagsReducer from '../features/customerTags/customerTagsSlice'
import customerTreeViewReducer from '../features/customerTreeView/customerTreeViewSlice'

export const store = configureStore({
    reducer: {
        customer: customerReducer,
        order: orderReducer,
        meta: metaReducer,
        alertDialogReducer,
        appReducer,
        assetSelectReducer,
        customerTagsReducer,
        customerTreeViewReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(logMiddleware()),
})

export const createTestStore = () => {
    const store = configureStore({
        reducer: {
            customer: customerReducer,
            order: orderReducer,
        },
    })
    return store
}

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>
